<template>
    <div>
        <v-app-bar
                app
                dark
                clipped-left
                extended
                :extension-height="$vuetify.breakpoint.lgAndUp? '80px':$vuetify.breakpoint.mdAndUp? '120px':'0px'"
                v-if="the_overlay!==null"
                hide-on-scroll
                height="100"
                class="stack_me"

        >
            <v-layout  row>
                <v-toolbar-title class="text-uppercase grey--text"

                                 @click="goHome"
                                 style="cursor:pointer;position:relative"
                >
                    <v-img
                            style="color:white;text-shadow: 1px 1px 6px black;z-index: 17;position:relative;"

                            :src="require('../assets/logo.png')"
                            :height="24"
                            :width="80"
                            contain

                    ></v-img>

                </v-toolbar-title>

                <v-toolbar-items style="z-index: 7;" class="ml-10 hidden-sm-and-down">

                    <v-btn class="text-lowercase font-weight-light" router
                           :to="'/'" tile text>
                        Start
                    </v-btn>

                    <v-btn :to="'/donations'" class="text-lowercase font-weight-light"  text>
                        Donationer
                    </v-btn>

                    <v-btn :to="'/hicards'"  class="text-lowercase font-weight-light"  text>
                        Hicards
                    </v-btn>
                    <v-btn :to="'/spons'"  class="text-lowercase font-weight-light"  text>
                        Spons
                    </v-btn>
                    <v-btn :to="'/events'"  class="text-lowercase font-weight-light"  text>
                        Events
                    </v-btn>

                    <v-btn :to="'/about'"  class="text-lowercase font-weight-light"  text>
                        Om oss
                    </v-btn>
                </v-toolbar-items>
                <v-spacer></v-spacer>

                <v-spacer></v-spacer>
                <v-app-bar-nav-icon app @click="$store.state.APP.DRAWER_MENU = !$store.state.APP.DRAWER_MENU"  style="position: relative;z-index: 8;"  class="justify-center" v-if="$vuetify.breakpoint.smAndDown && $store.getters.loggedIn"></v-app-bar-nav-icon>

                <v-btn app style="z-index: 8;" v-if="!$store.getters.loggedIn" @click="$store.state.APP.SHOW_LOGIN=true" text >
                    <span style="">Logga in</span>
                    <v-icon style="" right>mdi-login</v-icon>
                </v-btn>
            </v-layout>
            <v-layout row>
                <v-tabs
                        style="border-radius: 10px;"
                        v-model="selected_overlay"
                        centered
                        hide-slider
                        show-arrows


                >
                    <v-btn
                            text style="height:100%;background:transparent"
                            @click="createNewOverlay=true"
                    >
                        <v-icon left>add</v-icon>
                        Ny</v-btn>

                    <v-tab
                            v-for="(widget,index) in donation_widgets"
                            :key=index
                    >

                        {{widget.NAME}}

                    </v-tab>
                    <v-spacer>
                    </v-spacer>

                    <v-btn
                            :disabled="donation_widgets.length<2"
                            @click="the_overlay.delete" icon style="height:100%;background:transparent">
                        <v-icon >delete</v-icon>
                    </v-btn>



                </v-tabs>
            </v-layout>


            <template
                    v-slot:extension >
                <v-container style="    max-width: none;">

                    <v-layout row v-if="$vuetify.breakpoint.mdAndUp" style="">

                        <v-text-field
                                style="max-width: 300px;"
                                type="password"
                                :value="the_overlay.url"
                                outlined
                                label="Browser-länk"
                                class="mx-1"
                                dense
                                readonly

                                hide-details
                        >

                            <v-btn small v-clipboard:copy="the_overlay.url"  slot="append" icon >
                                <v-icon>mdi-content-copy</v-icon>
                            </v-btn>
                        </v-text-field>
                        <v-text-field
                                style="max-width:200px;"
                                class="mx-1"
                                v-model="donation_widgets[selected_overlay].NAME"
                                label="Overlay-namn"
                                outlined
                                hide-details

                                dense
                        ></v-text-field>
                        <div style="display:flex;" v-if="the_overlay.type==='DONATION'">
                            <v-text-field
                                    v-model="the_overlay.setup.DURATION"
                                    class="give_me_spin mx-1"
                                    label="Alert-längd"
                                    outlined
                                    dense
                                    style="max-width:120px;"

                                    type="number"
                                    suffix="s"
                            ></v-text-field>
                            <v-text-field
                                    v-model="the_overlay.setup.MIN_DONATION"
                                    class="give_me_spin mx-1"
                                    label="Minsta-donation"
                                    outlined
                                    dense
                                    style="max-width:120px;"
                                    type="number"
                                    suffix="kr"

                            ></v-text-field>


                            <v-text-field
                                    v-model="the_overlay.setup.MAX_DONATION"
                                    class="give_me_spin mx-1"
                                    label="Högsta-donation"
                                    outlined
                                    style="max-width:160px;"
                                    clearable

                                    value="Ingen"

                                    dense
                                    :type="(the_overlay.setup.MAX_DONATION===null || the_overlay.setup.MAX_DONATION==='Ingen')? '':'number'"
                                    :min="the_overlay.setup.MIN_DONATION"
                                    :suffix="(the_overlay.setup.MAX_DONATION===null || the_overlay.setup.MAX_DONATION==='Ingen')? '':'kr'"
                            >
                            </v-text-field>
                        </div>
                        <div style="display:flex;" v-if="the_overlay.type==='GOAL'">
                            <v-text-field
                                    v-model="the_overlay.setup.MIN_DONATION"
                                    class="give_me_spin mx-1"
                                    label="Insamlat"
                                    outlined
                                    dense
                                    style="max-width:120px;"
                                    type="number"
                                    suffix="kr"

                            ></v-text-field>


                            <v-text-field
                                    v-model="the_overlay.setup.MAX_DONATION"
                                    class="give_me_spin mx-1"
                                    label="Mål"
                                    outlined
                                    style="max-width:120px;"


                                    dense
                                    :min="the_overlay.setup.MIN_DONATION"
                                    suffix="kr"
                            >
                            </v-text-field>

                        </div>










                        <v-spacer></v-spacer>
                        <v-switch
                                v-if="the_overlay.type==='DONATION'"

                                class="mx-2"
                                v-model="the_overlay.lock_alert"
                                :prepend-icon="the_overlay.lock_alert? 'mdi-pin':'mdi-pin-off'"
                                label="Pinna"
                                style="margin-top:10px;"

                        ></v-switch>
                        <v-btn v-if="the_overlay!==null" tile color="teal"      @click="test_dialog=true" class="" dark>Skicka TEST</v-btn>
                        <v-btn v-if="the_overlay!==null" tile color="teal"  @click="the_overlay.send_test" class="mr-0"><v-icon>mdi-replay</v-icon></v-btn>


                        <v-btn   tile  color="teal" @click="the_overlay.save" class="mx-4" dark> <v-icon left>save</v-icon>Spara</v-btn>
                    </v-layout>

                </v-container>



            </template>


        </v-app-bar >



        <v-tabs-items dark v-model="selected_overlay" >
            <v-tab-item
                    transition="fade-transition"
                    reverse-transition="fade-transition"
                    v-for="(widget,index) in donation_widgets"
                    :key=index
                    eager

            >
            <DonationOverlay   :key=widget.ID  :donation_data="d_d"   :type="widget.TYPE" v-on:deleted="get_widgets" :name="widget.NAME"  v-on:register="register" :is_active="index===selected_overlay" :ref="'overlay'+widget.ID" :editable=true v-if="widget.NAME" :setup_data=get_data(widget.SETUP) :id_given="widget.ID"></DonationOverlay>
            </v-tab-item>
        </v-tabs-items>

        <v-dialog
                v-model="createNewOverlay"
                max-width="900"
        >
            <v-card dark>
                <v-card-title>Ny Overlay</v-card-title>
                <v-container>
                    <v-row dense>
                        <v-col lg="6"
                               md="12">
                            <v-card
                                    dark
                                    link
                                    style="background: linear-gradient(279deg, rgb(136 136 136) 0%, rgb(103 103 103) 100%);"
                                    @click="new_overlay('default1')"


                            >
                                <div class="d-flex flex-no-wrap justify-space-between">
                                    <div>
                                        <v-card-title
                                                class="headline"

                                        >Alert</v-card-title>

                                        <v-card-subtitle>Skapa din egen alert med stöd för gifs/webm, ljud och TTS. </v-card-subtitle>
                                    </div>

                                    <v-avatar
                                            class="ma-3"
                                            size="125"
                                            tile
                                    >
                                        <v-img :src="'/api/images/donation/default5_example.png'"></v-img>
                                    </v-avatar>
                                </div>
                            </v-card>

                        </v-col>
                        <v-col lg="6"
                               md="12">
                            <v-card
                                    dark
                                    link
                                    style="background: linear-gradient(279deg, rgb(136 136 136) 0%, rgb(103 103 103) 100%);"
                                    @click="new_overlay('default2')"


                            >
                                <div class="d-flex flex-no-wrap justify-space-between">
                                    <div>
                                        <v-card-title
                                                class="headline"

                                        >Donation-bar</v-card-title>

                                        <v-card-subtitle >Konkretisera ett donationsmål med hjälp av en donation-bar</v-card-subtitle>
                                    </div>

                                    <v-avatar
                                            class="ma-3"
                                            size="125"
                                            tile
                                    >
                                        <v-img :src="'/api/images/donation/default6_example.png'"></v-img>
                                    </v-avatar>
                                </div>
                            </v-card>

                        </v-col>


                    </v-row>
                </v-container>
                <v-card-subtitle style="padding-bottom: 0;">Templates</v-card-subtitle>
                <v-container>
                    <v-row dense>
                        <v-col lg="6"
                               md="12">
                            <v-card
                                    dark
                                    link
                                    style="background: linear-gradient(279deg, rgb(206 91 255) 0%, rgb(226 27 122) 100%);"
                                    @click="new_overlay('retro')"
                            >
                                <div class="d-flex flex-no-wrap justify-space-between">
                                    <div>
                                        <v-card-title
                                                class="headline"

                                        >Retro</v-card-title>

                                        <v-card-subtitle ><br>+ Avsändarnamn <br> + Donationsbelopp <br> + TTS</v-card-subtitle>
                                    </div>

                                    <v-avatar
                                            class="ma-3"
                                            size="125"
                                            tile
                                    >
                                        <v-img :src="'/api/images/donation/default_example.png'"></v-img>
                                    </v-avatar>
                                </div>
                            </v-card>

                        </v-col>
                        <v-col lg="6"
                               md="12">
                            <v-card
                                    dark
                                    link
                                    style="background: linear-gradient(279deg, rgb(255 203 58) 0%, rgb(202 82 12) 100%);"
                                    @click="new_overlay('kapow')"


                            >
                                <div class="d-flex flex-no-wrap justify-space-between">
                                    <div>
                                        <v-card-title
                                                class="headline"

                                        >Kapooow!</v-card-title>

                                        <v-card-subtitle ><br>+ Avsändarnamn <br> + Donationsbelopp <br> + TTS</v-card-subtitle>
                                    </div>

                                    <v-avatar
                                            class="ma-3"
                                            size="125"
                                            tile
                                    >
                                        <v-img :src="'/api/images/donation/default2_example.png'"></v-img>
                                    </v-avatar>
                                </div>
                            </v-card>

                        </v-col>

                        <v-col lg="6"
                               md="12">
                            <v-card
                                    dark
                                    link
                                    style="background: linear-gradient(279deg, rgb(255 148 148) 0%, rgb(255 109 109) 100%);"
                                    @click="new_overlay('love')"


                            >
                                <div class="d-flex flex-no-wrap justify-space-between">
                                    <div>
                                        <v-card-title
                                                class="headline"

                                        >Love</v-card-title>

                                        <v-card-subtitle ><br>+ Avsändarnamn <br> + Donationsbelopp <br> + Meddelande</v-card-subtitle>
                                    </div>

                                    <v-avatar
                                            class="ma-3"
                                            size="125"
                                            tile
                                    >
                                        <v-img :src="'/api/images/donation/default4_example.png'"></v-img>
                                    </v-avatar>
                                </div>
                            </v-card>

                        </v-col>
                        <v-col lg="6"
                               md="12">
                            <v-card
                                    dark
                                    link
                                    style="background: linear-gradient(279deg, rgb(255 0 0) 0%, rgb(176 19 19) 100%);"
                                    @click="new_overlay('hehegoal')"


                            >
                                <div class="d-flex flex-no-wrap justify-space-between">
                                    <div>
                                        <v-card-title
                                                class="headline"

                                        >Fiery</v-card-title>

                                        <v-card-subtitle ><br>+ Donationsmål med eldig bakgrund</v-card-subtitle>
                                    </div>

                                    <v-avatar
                                            class="ma-3"
                                            size="125"
                                            tile
                                    >
                                        <v-img :src="'/api/images/donation/default3_example.png'"></v-img>
                                    </v-avatar>
                                </div>
                            </v-card>

                        </v-col>

                    </v-row>
                </v-container>
                <v-card-subtitle style="padding-bottom: 0;">Skapa kopia från:</v-card-subtitle>
                <div class="text-left ma-4"  >
                    <v-btn @click="new_overlay(widget.ID)" v-for="(widget, index) in donation_widgets" :key="index" class="ma-2" tile color="indigo" dark>{{widget.NAME}}</v-btn>
                </div>

            </v-card>
        </v-dialog>

        <v-dialog v-model="test_dialog" max-width="600px">
            <v-card dark>
                <v-card-title>
                    <span class="headline">Testdonation</span>
                </v-card-title>
                <v-card-text>
                    <v-container>
                        <v-row>
                            <v-col cols="6">
                                <v-text-field label="Avsändarnamn" ref="name_temp"  v-model="SENDER_NAME_TEMP" required></v-text-field>
                            </v-col>
                            <v-col cols="6">
                                <v-text-field type="number" ref="amount_temp"  v-model="AMOUNT_TEMP" label="Summa" ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-textarea label="Meddelande" ref="message_temp" v-model="MESSAGE_TEMP"  >

                            </v-textarea>
                        </v-row>
                    </v-container>


                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn                 v-if="the_overlay!==null"
                                            color="teal" text @click="test">Skicka</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>


        <v-bottom-navigation
                height="100"
                app
                v-if="!$vuetify.breakpoint.mdAndUp && the_overlay!==null"
                dark
        >
            <v-btn
                    dark
                    @click.stop="more_info_dialog = true"
            >
                <v-icon>info</v-icon>
            </v-btn>

            <v-dialog
                    v-model="more_info_dialog"
                    max-width="290"
            >
                <v-card dark>
                    <v-card-text>
                        <v-container>
                            <v-row>
                                <v-col>
                                    <v-text-field
                                            style=""
                                            type="password"
                                            :value="the_overlay.url"
                                            outlined
                                            label="Browser-länk"
                                            dense
                                            readonly

                                            hide-details
                                    >

                                        <v-btn small v-clipboard:copy="the_overlay.url"  slot="append" icon >
                                            <v-icon>mdi-content-copy</v-icon>
                                        </v-btn>
                                    </v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col>
                                    <v-text-field
                                            v-model="donation_widgets[selected_overlay].NAME"
                                            label="Overlay-namn"
                                            outlined
                                            hide-details

                                            dense
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col>
                                    <div  v-if="the_overlay.type==='DONATION'">
                                        <v-text-field
                                                v-model="the_overlay.setup.DURATION"
                                                class="give_me_spin mx-1"
                                                label="Alert-längd"
                                                outlined
                                                dense

                                                type="number"
                                                suffix="s"
                                        ></v-text-field>
                                        <v-text-field
                                                v-model="the_overlay.setup.MIN_DONATION"
                                                class="give_me_spin mx-1"
                                                label="Minsta-donation"
                                                outlined
                                                dense
                                                type="number"
                                                suffix="kr"

                                        ></v-text-field>


                                        <v-text-field
                                                v-model="the_overlay.setup.MAX_DONATION"
                                                class="give_me_spin mx-1"
                                                label="Högsta-donation"
                                                outlined
                                                clearable

                                                value="Ingen"

                                                dense
                                                :type="(the_overlay.setup.MAX_DONATION===null || the_overlay.setup.MAX_DONATION==='Ingen')? '':'number'"
                                                :min="the_overlay.setup.MIN_DONATION"
                                                :suffix="(the_overlay.setup.MAX_DONATION===null || the_overlay.setup.MAX_DONATION==='Ingen')? '':'kr'"
                                        >
                                        </v-text-field>
                                    </div>
                                    <div v-if="the_overlay.type==='GOAL'">
                                        <v-text-field
                                                v-model="the_overlay.setup.MIN_DONATION"
                                                class="give_me_spin mx-1"
                                                label="Insamlat"
                                                outlined
                                                dense
                                                type="number"
                                                suffix="kr"

                                        ></v-text-field>


                                        <v-text-field
                                                v-model="the_overlay.setup.MAX_DONATION"
                                                class="give_me_spin mx-1"
                                                label="Mål"
                                                outlined


                                                dense
                                                :min="the_overlay.setup.MIN_DONATION"
                                                suffix="kr"
                                        >
                                        </v-text-field>

                                    </div>
                                </v-col>
                            </v-row>



                        </v-container>
                    </v-card-text>



                </v-card>
            </v-dialog>
            <v-btn v-if="the_overlay!==null" tile color="teal"     icon  @click="test_dialog=true" class="" ><v-icon>mdi-send</v-icon></v-btn>
            <v-btn v-if="the_overlay!==null" icon color="teal"  @click="the_overlay.send_test" class="mr-0"><v-icon>mdi-replay</v-icon></v-btn>


            <v-btn   icon color="teal" @click="the_overlay.save" class="mx-4" dark> <v-icon >save</v-icon></v-btn>



        </v-bottom-navigation>



    </div>

</template>

<script>

    import DonationOverlay from "../components/DonationOverlay";


    export default {
        name: "DonationOverlays",
        components:{
            DonationOverlay

        },
        data(){
            return{
                selected_overlay:0,
                donation_widgets:[],
                the_overlay:null,
                max_donation:false,
                createNewOverlay:false,
                AMOUNT:10,
                SENDER_NAME:"Namn123",
                MESSAGE:"Testdonation från Hihat!",
                AMOUNT_TEMP:10,
                SENDER_NAME_TEMP:"Namn123",
                MESSAGE_TEMP:"Testdonation från Hihat!",
                test_dialog:false,
                updateCount:0,
                more_info_dialog:false


            }
        },
        mounted:function(){
            document.title="Hihat - Overlays";

            this.get_widgets();
        },
        methods:{
            test:function(){
                this.AMOUNT=this.AMOUNT_TEMP;
                this.SENDER_NAME=this.SENDER_NAME_TEMP;
                this.MESSAGE=this.MESSAGE_TEMP;
                let self=this;
                this.test_dialog=false;
                setTimeout(function(){
                    self.the_overlay.send_test();
                },500);


            },
            set_max:function() {
                this.max_donation = !this.max_donation;
                if (!this.max_donation) {
                    this.setup.MAX_DONATION = null
                } else {
                    this.setup.MAX_DONATION = null;

                }
            },

            new_overlay:function(id){

                let http = new XMLHttpRequest();
                http.withCredentials = true;
                let url = '/api/new_donation_widget';


                let params ="NAME="+'Overlay '+(this.donation_widgets.length+1)+"&COPY="+id;
                let self=this;
                http.open('POST', url, true);
                http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
                http.onreadystatechange = function() {//Call a function when the state changes.
                    if(http.readyState === 4 && http.status === 200) {
                        self.get_widgets();


                    }
                };
                http.send(params);
            },
            register:function(context){
              this.the_overlay=context;
            },
            send_test:function(){
                this.the_overlay.send_test();
            },

            goHome:function(){
                this.$router.push({ path: '/' })
            },
            get_widgets(){
                let http = new XMLHttpRequest();
                let url = '/api/get_donation_widgets';
                http.open('GET', url, true);
                http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
                let self=this;
                http.onreadystatechange = function() {

                    if(http.readyState === 4 && http.status === 200) {
                        self.createNewOverlay=false;
                        self.donation_widgets=[];

                        self.donation_widgets=JSON.parse(http.response);
                        self.selected_overlay=0




                    }
                };
                http.send();
            },
            get_data:function(setup){
                    try{
                        return JSON.parse(setup)

                    }
                    catch(error){
                        return null
                    }






            }
        },
        computed:{
            d_d:function(){
                return {
                    AMOUNT:this.AMOUNT,
                    MESSAGE:this.MESSAGE,
                    SENDER_NAME:this.SENDER_NAME
                }
            }
        },
        watch:{
            "the_overlay.setup.MAX_DONATION":function(){
                if(this.the_overlay.setup.MAX_DONATION===null){
                    this.the_overlay.setup.MAX_DONATION="Ingen"
                }
            }
        }


    }
</script>

<style >
    .stack_me > div{
        display: grid;
        top: 10px;
        left: 10px;
    }
</style>
